import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./delete-documents-confirmation-dialog.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./delete-documents-confirmation-dialog.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { AppConfig } from "../../../../app.config";
let DeleteDocumentsConfirmationDialogComponent = class DeleteDocumentsConfirmationDialogComponent {
    activeModal;
    dialogTitle;
    documentsToDelete;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    cancelBtnPlaceholder = "Cancel";
    saveBtnPlaceholder = "Delete";
    dialogMessage = "Are you sure that you want to delete the selected document(s) from the table?";
    constructor(activeModal) {
        this.activeModal = activeModal;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
    }
    onCancelBtnClicked() {
        this.activeModal.close();
    }
    onDeleteBtnClicked() {
        this.activeModal.close(this.documentsToDelete);
    }
    static ctorParameters = () => [
        { type: NgbActiveModal }
    ];
    static propDecorators = {
        dialogTitle: [{ type: Input }],
        documentsToDelete: [{ type: Input }]
    };
};
DeleteDocumentsConfirmationDialogComponent = __decorate([
    Component({
        selector: "app-delete-documents-confirmation-dialog",
        template: __NG_CLI_RESOURCE__0,
        host: { "delete-documents-confirmation-dialog": "view-application" },
        styles: [__NG_CLI_RESOURCE__1]
    })
], DeleteDocumentsConfirmationDialogComponent);
export { DeleteDocumentsConfirmationDialogComponent };
